import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import { Modal } from 'semantic-ui-react';
import './styles.css';

function CarouselLib({
  images,
  closeHandler,
}: {
  images: string[];
  closeHandler: () => void;
}) {
  return (
    <Modal open onClose={closeHandler}>
      <Carousel className="carousel-wrapper">
        {images?.map((image) => (
          <div>
            <img src={image} alt={'images'} />
          </div>
        ))}
      </Carousel>
    </Modal>
  );
}

export default CarouselLib;
